import { API, buildQueryParams, get } from "api";
import { FilterViewModel } from "api/factories/ulits.factory";
import { getLocalStorageAccessToken } from "utils";

// TODO: Fix probably name of the function is incorrect since this endpoint probably will handle all filter fields
/**
 * Get customers
 * @param source
 * @param searchValue
 * @param filter
 * @param headers
 */
export const fetchFilterAutocompleteOptions = async (
    source: string,
    searchValue: string,
    filter: FilterViewModel,
    headers?: HeadersInit
): Promise<string[]> => {
    headers = {
        Authorization: `Bearer ${getLocalStorageAccessToken()}`,
    };
    const { parsedBody } = await get<{ data: string[] }>(
        `${API.baseApiUrl}/${source}?${buildQueryParams({
            text: searchValue,
            field: filter.name,
            operator: filter.operator,
        })}`,
        { headers }
    );

    return parsedBody?.data || [];
};

/**
 * Get material specifications
 * @param params
 * @param headers
 */
export const fetchMaterialSpecAutocompleteOptions = async (
    params: {
        field: string;
        value: string;
    },
    headers?: HeadersInit
): Promise<string[]> => {
    headers = {
        Authorization: `Bearer ${getLocalStorageAccessToken()}`,
    };
    const { parsedBody } = await get<{ matspecname: { systemid: string; name: string }[] }>(
        `${API.baseApiUrl}/email-templates/autocomplete?${buildQueryParams(params)}`,
        { headers }
    );

    return parsedBody?.matspecname.map(({ name }) => name) || [];
};

export default {
    fetchFilterAutocompleteOptions,
    fetchMaterialSpecAutocompleteOptions,
};
